import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { MsalInterceptor } from '@azure/msal-angular';
import { BcEmployeeAuthInterceptor } from '@bayclubs/employee-auth';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class DualAuthInterceptor implements HttpInterceptor {
    private readonly injector = inject(Injector);
    private delegate?: HttpInterceptor;

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.delegate) {
            this.delegate = environment.isMsalAuthenticationEnabled
                ? this.injector.get(MsalInterceptor)
                : this.injector.get(BcEmployeeAuthInterceptor);
        }
        return this.delegate.intercept(req, next);
    }
}
